<!-- eslint-disable n/prefer-global/process -->
<script setup lang="ts">
import { shallowRef } from 'vue'
import dayjs from 'dayjs'
import { Error, Loading } from '@ui'
import { useSeoMeta } from '#imports'

defineProps({
  cssVars: {
    type: Object,
    default: () => {},
  },
})
definePageMeta({
  name: 'index',
  // Set SEO from store data
})

useSeoMeta({
  // will be inferred as the lastmod value in the sitemap
  articleModifiedTime: dayjs(new Date()).toISOString(),
})

const component = shallowRef({})
const isLoading = ref(false)

try {
  component.value = await resolveComponent('ComponentsHome')
  // throw createError({
  //   statusCode: 404,
  //   statusMessage: 'Page Not Found',
  //   fatal: true,
  // })
}
catch (e) {
  component.value = Error
}
</script>

<template>
  <component :is="isLoading ? Loading : component" />
</template>
